import './new-leave-category.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateLeaveCategory } from "@core/query/leave-category.query";
import { LeaveCategoryFormRule, LeaveCategoryFormSchema } from "@core/form/form.rule";
import { leaveCategoryFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormLeaveCategory from "../form-leave-category/form-leave-category";

export function LeaveCategory() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateLeaveCategory } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New LeaveCategory is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addLeaveCategory, isLoading: isCreating } =
    useQyCreateLeaveCategory(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<LeaveCategoryFormSchema>({
    defaultValues: leaveCategoryFormDefault,
    resolver: zodResolver(LeaveCategoryFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: LeaveCategoryFormSchema) => {
    const formData = mapCreateLeaveCategory(form);
    addLeaveCategory(formData);
  };
  const handleValidateError = (err: FieldErrors<LeaveCategoryFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="LeaveCategory" className="leave-category">
      <HeaderContent
        title="New Leave Category"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormLeaveCategory />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default LeaveCategory;